<template>
  <div>
    <div class="card-body mb-0 pb-0">
      <h5>
        Rider info
      </h5>
      <table class="table table-sm table-hover">
        <tbody>
          <tr v-for="(value, attribute) in filteredRiderInfo" :key="attribute">
            <td>{{ value.verboseName }}</td>
            <td>
              {{ displayMethod(rider[attribute], value.displayRepresentation) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "RiderDetail",
  props: {
    raceShortName: { type: String, default: "SRMR2023" },
    baseURL: String,
    rider: Object,
    riderInfo: Object,
  },
  computed: {
    filteredRiderInfo() {
      // Only show Wave field if rider has a wave (indicating staggered race)
      if (!this.rider.wave) {
        // Create a copy of riderInfo without the wave field
        const filtered = { ...this.riderInfo };
        delete filtered.wave;
        return filtered;
      }
      return this.riderInfo;
    },
  },
  methods: {
    displayMethod(value, displayCallback) {
      if (displayCallback) {
        return displayCallback(value);
      }
      return value;
    },
  },
};
</script>

<style scoped>
.card-body {
  text-align: left;
}

.close-button {
  cursor: pointer;
}
</style>
